export default "__VITE_ASSET__CRaScQb___"